<div class="customer-info-wrap">

    @if (isEdit) {
    <edit-profile-info [profileInfo]="profileInfo" (save)="onSave($event)" (cancel)="onCancel()">
    </edit-profile-info>
    } @else {
    <div class="customer-info-box">

        <div class="customer-info-item customer-info-item--name rpc-title-font">
            {{ profileInfo?.firstName + ' ' + profileInfo?.lastName }}
        </div>

        <div class="customer-info-item  customer-info-item--email">
            {{ profileInfo?.userName }}
        </div>

        <div class="customer-info-btn-wrap">

            <rpc-button class="customer-info-btn" [color]="'accent'" [text]="'PROFILE_TOP.TITLES.EDIT'"
                [iconName]="'edit'" (clicked)="onEdit()">
            </rpc-button>

        </div>

    </div>
    }

</div>